import React, { useMemo } from 'react';
import routes from '../constants/routes';
import useCustomRouter from './useCustomRouter';
import { useUserDuck } from './useUserDuck';
import { MenuItem } from '@components/MyAccountMenuItem/MenuItemTemplate';

export const useAccountMenu = () => {
    const router = useCustomRouter();
    const {
        summary: { totalOrders, totalSaves },
    } = useUserDuck();

    const menuItems: MenuItem[] = useMemo(() => {
        return [
            {
                type: 'link',
                id: 'my-account',
                label: 'myaccount.nav.myAccount',
                href: routes.MY_ACCOUNT,
                isActive: routes.MY_ACCOUNT === router.asPath,
                dataTestId: 'TESTING_MYACCOUNT_SIDEMENUITEM',
            },
            {
                type: 'link',
                id: 'my-saves',
                label: 'myaccount.nav.mySaves',
                href: routes.MY_SAVES,
                isActive: router.asPath.startsWith(routes.MY_SAVES),
                total: totalSaves.total,
                dataTestId: 'TESTING_MYSAVES_SIDEMENUITEM',
            },
            {
                type: 'link',
                id: 'my-orders',
                label: 'myaccount.nav.myOrders',
                href: routes.MY_ORDERS,
                isActive: router.asPath.startsWith(routes.MY_ORDERS),
                total: totalOrders.total,
                dataTestId: 'TESTING_MYORDERS_SIDEMENUITEM',
            },
        ];
    }, [router.asPath, totalSaves, totalOrders]);

    return { menuItems };
};
